"use strict";

//here you can add js that is generic to all your Page Designer pages

